import { Grid, Box, Typography } from "@mui/material";
import { FC, useMemo, useRef } from "react";
import { isEqual } from "lodash";
import { ClassificationRuleAmbinetDataCotnext } from "./ClassificationRuleAmbientDataProvider";
import { useFileCataAmbientDataContext } from "./FileCataAmbientDataProvider";
import OwnershipPieChart from "./OwnershipPieChart";
import { osfCatalogRes, pfsCatalogRes, useFileCataSearchContext } from "./FileCataSearchContextProvider";
import { FileCatalogSearchInput } from "@/gen/api/securefile";



const FileCataOwnershipPieChart: FC = () => {
  const { filters, switchCurrRes, currRes } = useFileCataSearchContext()

  const searchFiltersRef = useRef(null as null|FileCatalogSearchInput)
  const searchFilters = useMemo(() => {
    const f : FileCatalogSearchInput = {
      term: filters.name,
      tags: filters.tags.map(t => t.tagId!),
      primaryClassifications: filters.primaryClassification.map(x => x == null ? (x as any) : Number(x)),
      secondaryClassifications: filters.secondClassification.map(x => x?.secondaryClassificationId as any),
      documentTypes: filters.documentTypes,
      infoTypes: filters.infoTypes,
      fileInstanceOptions: filters.fileInstanceOptions,
      dataOwnerGroupIds: filters.ownerGroup.map(x => x.ownerGroupId!),
    }
    if (isEqual(f, searchFiltersRef.current)) {
      return searchFiltersRef.current!
    }
    searchFiltersRef.current = f
    return f
  }, [filters])

  return (
    <Grid container spacing={4}>
      <CarryClassificationRuleProvider>
        <Grid item xs={12} sm={6}>
          <Box>
            <Typography variant="body1" color="text.primary" mb={1}>Encrypted Files</Typography>
            <OwnershipPieChart forPlainFiles={false} filters={searchFilters} 
              onDataPointClick={() =>{ if (currRes !== osfCatalogRes) switchCurrRes()}} 
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box>
            <Typography variant="body1" color="text.primary" mb={1}>Unencrypted Files</Typography>
            <OwnershipPieChart forPlainFiles={true} filters={searchFilters} 
              onDataPointClick={() =>{ if (currRes !== pfsCatalogRes) switchCurrRes()}} 
            />
          </Box>
        </Grid>
      </CarryClassificationRuleProvider>
    </Grid>
  )
}

export default FileCataOwnershipPieChart;

const CarryClassificationRuleProvider : FC = ({ children }) => {
  const { classifications } = useFileCataAmbientDataContext()

  return (
    <ClassificationRuleAmbinetDataCotnext.Provider value={{ classifications }} >
      {children}
    </ClassificationRuleAmbinetDataCotnext.Provider>
  )
}